import { useStore } from 'zustand';
import { useGridStoreApiOptional } from './GridStoreProvider';
import { emptyGridStore } from './gridStore';

interface UseCombinationPartsQuantityParams {
  combinationKey?: string;
  fallback: number;
}

export const useCombinationPartsQuantity = ({
  combinationKey,
  fallback,
}: UseCombinationPartsQuantityParams): number => {
  const api = useGridStoreApiOptional();
  const isStoreBacked = !!api && !!combinationKey;

  const combinationCells = useStore(api ?? emptyGridStore, (state) =>
    combinationKey ? state.cells[combinationKey] : undefined,
  );
  if (!isStoreBacked || !combinationKey) {
    return fallback;
  }

  return Object.values(combinationCells ?? {}).reduce((sum, cell) => sum + cell.quantity, 0);
};
